import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import PageSpinner from './GeneralForm/PageSpinner';
import {
  handleLayoutIsDisplaySidebar,
  handleLayoutSetUserInfo,
  handleLayoutSetDealerInfo,
  handleLayoutLoader,
  handleChangePasswordToggle,
  handleOpDecalsToggle,
  handleWindowStickerBuyersguideOrderToggle,
  handleLayoutScreenSizeObj,
  handleIsFullLayout,
  handleFullLayoutLoader
} from '../containers/MainLayout/mainLayoutSlice';
import PageHeading from './GeneralForm/PageHeading';

const PageComponent = ({
  tag: Tag,
  isPageHeader = { isvisible: false },
  children,
  className,
  isLoading,
  ...props
}) => {
  return (
    <>
      <PageSpinner isLoading={isLoading} isMainLayout={!props.isFullLayout} />
      <Tag className={`px-3 ${className}`}>
        {isPageHeader?.isvisible && <PageHeading {...isPageHeader} />}
        {children}
      </Tag>
    </>
  );
};

PageComponent.propTypes = {
  tag: PropTypes.elementType,
  children: PropTypes.any,
  className: PropTypes.string
};

PageComponent.defaultProps = {
  tag: 'div',
  className: ''
};

const mapStateToProps = state => ({
  isLoading: state.mainlayout.isLoading,
  isSidebarVisible: state.mainlayout.isSidebarVisible,
  user: state.mainlayout.user,
  dealer: state.mainlayout.dealer,
  changePasswordToggle: state.mainlayout.changePasswordToggle,
  opDecalsToggle: state.mainlayout.opDecalsToggle,
  isFullLayout: state.mainlayout.isFullLayout,
  screenSizeObj: state.mainlayout.screenSizeObj
});
const mapDispatchToProps = {
  handleLayoutIsDisplaySidebar,
  handleLayoutSetUserInfo,
  handleLayoutSetDealerInfo,
  handleLayoutLoader,
  handleChangePasswordToggle,
  handleOpDecalsToggle,
  handleWindowStickerBuyersguideOrderToggle,
  handleLayoutScreenSizeObj,
  handleIsFullLayout,
  handleFullLayoutLoader
};

PageComponent.displayName = 'PageComponent';
export default connect(mapStateToProps, mapDispatchToProps)(PageComponent);
